<!-- 创建时间2023/06/15 18:24:18 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：时长 -->
<template>
  <!-- {0}分{1}秒{2} -->
  <yxtbiz-language-slot lang-key="pc_biz_lbl_studytime">
    <template v-if="isCanEdit">
      <yxt-tooltip
        :disabled="canEditHours"
        slot="0"
        :content="$t('pc_biz_lbl_noeditauth'/** 无编辑权限 */)"
        >
        <yxt-input-number
          class="mr4"
          :disabled="disabled || !canEditHours"
          v-model="minute"
          :precision="0"
          :step="1"
          :max="999"
          :min="0"
        ></yxt-input-number>
      </yxt-tooltip>      
      <yxt-tooltip
        :disabled="canEditHours"
        slot="1"
        :content="$t('pc_biz_lbl_noeditauth'/** 无编辑权限 */)"
        >
        <yxt-input-number
          class="ml4 mr4"
          :disabled="disabled || !canEditHours"
          v-model="second"
          :precision="0"
          :step="1"
          :max="59"
          :min="0"
        ></yxt-input-number>
      </yxt-tooltip>
    </template>
    <template v-else>
      <span slot="0">{{ minute }}</span>
      <span slot="1">{{ second }}</span>
    </template>
    <span class="color-gray-6" slot="2">
      {{ tipText }}
    </span>
  </yxtbiz-language-slot>
</template>

<script>
import { KNG_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
export default {
  name: 'form-time',
  inject: ['getInfo', 'getPermissionConfig'],
  props: {
    value: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      KNG_TYPE,
      second: 0,
      minute: 0
    };
  },
  computed: {
    kngType() {
      return this.getInfo().type;
    },
    isCanEdit() {
      return [KNG_TYPE.SCORM, KNG_TYPE.HTML, KNG_TYPE.DOC].includes(this.kngType) ||
       (this.kngType === KNG_TYPE.WEIKE && this.getInfo().weikeType === 1);
    },
    tipText() {
      return this.kngType === KNG_TYPE.COURSE ? this.$t('pc_biz_lbl_studytimecalcauto'/** （标准时长和学分根据添加的课程内容自动计算） */) : this.$t('pc_biz_lbl_studytimeneed'/** （获取学分所需的学习时长）*/);
    },
    canEditHours() {
      return this.getPermissionConfig().editHours;
    }
  },
  created() {
    if (this.value === undefined) this.$emit('input', 0);
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.minute = parseInt(val / 60, 10);
        this.second = val - this.minute * 60;
      }
    },
    minute() {
      this.updateTime();
    },
    second() {
      this.updateTime();
    }
  },
  methods: {
    updateTime() {
      if (this.minute !== undefined || this.second !== undefined) {
        this.$emit('input', (this.minute || 0) * 60 + (this.second || 0));
      } else {
        this.$emit('input', undefined);
      }
      this.$emit('change');
    }
  }
};
</script>